import React from 'react'

import Icon, { Props } from './Icon'

const IconList: React.FC<Props> = (props) => {
  return (
    <Icon title="" viewBox="0 0 22.974 22.974" {...props}>
      <path d="M20.294 0H2.68A2.68 2.68 0 000 2.68v17.615a2.68 2.68 0 002.68 2.68h17.614a2.68 2.68 0 002.681-2.68V2.68A2.68 2.68 0 0020.295 0zM4.978 18.38a1.532 1.532 0 111.531-1.532 1.532 1.532 0 01-1.531 1.532zm0-5.361a1.532 1.532 0 111.531-1.532 1.531 1.531 0 01-1.531 1.532zm0-5.361a1.531 1.531 0 111.531-1.531 1.531 1.531 0 01-1.531 1.531zm13.019 10.723H9.573a1.532 1.532 0 010-3.064h8.424a1.532 1.532 0 010 3.064zm0-5.361H9.573a1.532 1.532 0 010-3.063h8.426a1.532 1.532 0 010 3.063zm0-5.361H9.573a1.532 1.532 0 110-3.063h8.428a1.532 1.532 0 110 3.063z" />
    </Icon>
  )
}

export default IconList
